import { render, staticRenderFns } from "./AssetSelectType.vue?vue&type=template&id=c21644be&"
import script from "./AssetSelectType.vue?vue&type=script&lang=js&"
export * from "./AssetSelectType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports